import React from "react";
import styled, { useTheme } from "styled-components";
import InfoBox from "./InfoBox";
import Alert from "../icons/Alert";

interface Props {
  label: string | JSX.Element;
  className?: string;
}

const RedInfoBox = ({ label, className }: Props) => {
  const theme = useTheme();
  return (
    <InfoBox
      className={className}
      label={label}
      borderColor={
        theme.redesign.searchResultsPage.flightDetailsModal.alertColor
      }
      textColor={theme.redesign.searchResultsPage.flightDetailsModal.alertColor}
      icon={
        <IconContainer>
          <Alert
            fill={
              theme.redesign.searchResultsPage.flightDetailsModal.alertColor
            }
          />
        </IconContainer>
      }
    />
  );
};

const IconContainer = styled.div`
  height: 16px;
  display: flex;
  svg {
    width: 16px;
    height: 16px;
  }
`;

export default RedInfoBox;
